var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchases-view mb-3"},[_c('page-title',{attrs:{"title":"Compras","icon":"cart-plus"}}),_c('purchase-filters-bar'),_c('purchases-list'),_c('purchase-transfer-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }